
<div class="modal-header">
  <h5 class="modal-title">{{'listino.import.title' | translate}}</h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row" >
    <div class="col-sm-12 col-md-12">
      <div class="form-group">
        <label for="fornitore" class="control-label col-form-label">{{'listino.import.fornitore' | translate}}</label>
        <ng-multiselect-dropdown [settings]="clientiDropdownSettings" [placeholder]="'listino.import.fornitore' | translate" id="fornitore"
                                 [data]="Fornitori" [(ngModel)]="FornitoriSelezionati"  (ngModelChange)="RespChange($event)" >
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="col-sm-12 col-md-12">
      <div class="form-group">
        <label for="data" class="control-label col-form-label">{{'listino.import.data' | translate}}:</label>
        <input type="date" [(ngModel)]="data" (ngModelChange)="RespChange($event)" class="form-control" id="data">
      </div>
    </div>
    <div class="col-sm-12 col-md-12">
      <app-import-component #ImportComponent (Uploaded)="uploaded()" [isModal]="false" ></app-import-component>
    </div>
  </div>
</div>

